import type { ConcreteRequest } from 'relay-runtime';

import Query, { type AggListQuery as generatedAggListQueryType } from './__generated__/AggListQuery.graphql';

export type AggListQueryType = generatedAggListQueryType;

export const AggListQuery: ConcreteRequest = Query;
